import React, { useEffect, useRef } from 'react';

const CTA: React.FC = () => {
  const ctaRef = useRef<HTMLElement>(null);
  const backgroundRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!ctaRef.current || !backgroundRef.current || !contentRef.current) return;
      
      const rect = ctaRef.current.getBoundingClientRect();
      
      // Parallax hanya aktif ketika section sudah sampai di atas layar
      if (rect.top <= 0 && rect.bottom > 0) {
        const scrolled = window.pageYOffset;
        const sectionTop = ctaRef.current.offsetTop;
        const scrollDistance = scrolled - sectionTop;
        
        // Parallax effect untuk background
        backgroundRef.current.style.transform = `translateY(${scrollDistance * 0.5}px)`;
        
        // Parallax effect untuk content (lebih halus)
        contentRef.current.style.transform = `translateY(${scrollDistance * 0.3}px)`;
      } else {
        // Reset transform ketika section belum sampai di atas layar
        backgroundRef.current.style.transform = 'translateY(0)';
        contentRef.current.style.transform = 'translateY(0)';
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial call
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <style>{`
        .cta-section {
          position: relative;
          min-height: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 120px 48px;
          overflow: hidden;
        }

        .cta-background {
          position: absolute;
          top: -20%;
          left: 0;
          width: 100%;
          height: 140%;
          z-index: 0;
          background-image: url('/assets/cta.jpg');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          transition: transform 0.1s ease-out;
        }

        .cta-content {
          position: relative;
          z-index: 1;
          max-width: 900px;
          text-align: center;
          transition: transform 0.1s ease-out;
        }

        .cta-text {
          font-size: clamp(24px, 4vw, 42px);
          font-weight: 600;
          line-height: 1.4;
          color: #ffffff;
          margin: 0;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
        }

        @media (max-width: 768px) {
          .cta-section {
            padding: 80px 24px;
            min-height: 400px;
          }

          .cta-background {
            height: 120%;
          }
        }
      `}</style>
      <section className="cta-section" ref={ctaRef}>
        <div className="cta-background" ref={backgroundRef}></div>
        <div className="cta-content" ref={contentRef}>
          <p className="cta-text">
            Kami membantu bisnis mereduksi kompleksitas operasional agar perusahaan dan pelanggan dapat terhubung dengan lebih sederhana dan efektif.
          </p>
        </div>
      </section>
    </>
  );
};

export default CTA;
